export default {
	gitRemote: {
		title: "Git-Remote",
		hint: "Der Server pusht den Verlauf dieses Projekts an das hier eingerichtete Remote — nach jedem automatischen Build und nach jedem Release samt Tag.",
		url: "Repository-URL",
		urlHelp: "https://…, ssh://… oder user{'@'}host:pfad",
		urlInvalid:
			"Geben Sie eine https-, http- oder ssh-URL oder user{'@'}host:pfad an. Ein Pfad auf dem Server ist nicht erlaubt.",
		branch: "Branch",
		auth: "Authentifizierung",
		authNone: "Keine",
		authToken: "Token",
		authSsh: "SSH-Schlüssel",
		username: "Benutzername",
		usernameHelp:
			"Der Name, den Ihr Git-Server zusammen mit dem Token erwartet. Die meisten akzeptieren jeden beliebigen Namen.",
		token: "Token",
		sshKey: "Privater SSH-Schlüssel",
		sshKeyHelp: "Den ganzen Schlüssel einfügen, mit den BEGIN- und END-Zeilen.",
		secretStored: "Ein Token oder Schlüssel ist gespeichert und wird nie wieder angezeigt.",
		replaceSecret: "Ersetzen",
		keepSecret: "Gespeicherten behalten",
		secretNeeded: "Ein Token oder Schlüssel wird benötigt.",
		save: "Speichern",
		remove: "Nicht mehr pushen",
		pushNow: "Jetzt pushen",
		statusNone: "Kein Remote: Dieses Projekt wird nirgendwohin gepusht.",
		statusNever: "Noch nicht gepusht.",
		statusOk: "Zuletzt gepusht am {time}.",
		statusFailed: "Der letzte Push am {time} ist fehlgeschlagen:",
		saved: "Remote gespeichert. Der nächste Push geht dorthin.",
		removed: "Das Projekt wird nicht mehr gepusht.",
		pushed: "Gepusht.",
		pushFailed: "Der Push ist fehlgeschlagen.",
		readOnly:
			"Nur ein Mitglied, das in den Verlauf des Projekts schreiben darf, kann das ändern.",
	},
	cloneProject: {
		title: "Aus Git klonen",
		hint: "Legt ein neues Projekt aus dem Repository eines Notitia-Projekts an. Sie werden dessen Admin, und das Repository wird dessen Push-Remote.",
		action: "Klonen",
	},
};
